import api from '@/api/spotify'

export default {

  init (token, vuePlayer) {
    // set default header on axios object
    api.defaults.headers['Authorization'] = 'Bearer ' + token

    window.deviceId = ''

    const script = document.createElement('script')
    script.src = 'https://sdk.scdn.co/spotify-player.js'
    script.async = true
    document.body.appendChild(script)

    // prep the local player
    window.onSpotifyWebPlaybackSDKReady = () => {
      const spotifyPlayer = new window.Spotify.Player({
        name: 'Long Player',
        getOAuthToken: cb => { cb(token) },
        volume: 0.5
      })

      // Error handling
      spotifyPlayer.addListener('initialization_error', ({ message }) => { console.error(message) })
      spotifyPlayer.addListener('authentication_error', ({ message }) => { console.error(message) })
      spotifyPlayer.addListener('account_error', ({ message }) => { console.error(message) })
      spotifyPlayer.addListener('playback_error', ({ message }) => { console.error(message) })

      // Playback status updates
      spotifyPlayer.addListener('player_state_changed', state => {
        vuePlayer.onStateChanged(state)
      })

      // Ready
      spotifyPlayer.addListener('ready', (args) => {
        console.log('Ready with Device ID', args.device_id)
        window.deviceId = args.device_id
      })

      // Not Ready
      spotifyPlayer.addListener('not_ready', (args) => {
        console.log('Device ID has gone offline', args.device_id)
      })

      // Connect to the player!
      spotifyPlayer.connect()

      window.webPlayer = spotifyPlayer
    }
  },

  skipTrack () {
    window.webPlayer.nextTrack()
  },

  disableShuffle () {
    return api.put('me/player/shuffle?state=false&device_id=' + window.deviceId)
      .then(() => {
        console.log('shuffle disabled successfully')
      })
      .catch((e) => {
        console.log(e)
      })
  },

  playAlbum (uri) {
    return api.put('me/player/play?device_id=' + window.deviceId, {'context_uri': 'spotify:album:' + uri})
      .then(() => {
        console.log('album has been played via put')
      })
  },

  togglePlayer () {
    window.webPlayer.togglePlay()
  },

  getNowPlaying () {
    return api.get('me/player')
  }
}



// WEBPACK FOOTER //
// ./src/services/Spotify.js